import React from 'react'
import ProductDetails_Banner from './ProductDetails_Banner/ProductDetails_Banner'
import Product_Infomation from './Product_Infomation/Product_Infomation'

const ProductDetails = () => {
  return (
    <div>
        <ProductDetails_Banner/>
        <Product_Infomation/>
    </div>
  )
}

export default ProductDetails